import { AddStaticText } from "../utils/AddStaticText";
import { enumFillMode, enumPanelBorderStyle } from "../constants";
import { uFramelessPanelColorDarker } from "../whitelabel/brand";
import { QPanel } from "./QPanel";
import { TruncateText } from "../utils/TruncateText";
import { AddWrapText } from "../utils/AddWrapText";

export class QToolTip extends QPanel {
  constructor() {
    super();
    this.ResetSize();
    this.fRenderPhoenix = true;
  }

  ResetSize() {
    this.fToolW = 210;
    this.fToolH = 50;
  }

  SetTipSize(width, height) {
    this.fToolW = width;
    this.fToolH = height;
  }

  Init(hoverElement, hoverMsg, x, y, yTop, maxW, maxH) {
    var fullMsg = false;
    if (hoverMsg.fLongText != null && hoverMsg.fLongText.length > 0) fullMsg = true;

    var resizeBehavior = this.GetResizeBehavior(); // defaults to top left
    var pinRight = resizeBehavior.fPinRight;
    var pinBottom = resizeBehavior.fPinBottom;

    if (pinRight) {
      // Move right
      x = x + hoverElement.fWidth;
      if (x > maxW) x = maxW;
    }
    if (pinBottom) {
      // Move down
      y = y + hoverElement.fHeight;
      if (y > maxH) y = maxH;
    }

    var kShiftDown = 10;
    this.SetModalOn(false);

    this.SetZLayer(6);

    this.SetFillMode(enumFillMode.solidFill);

    this.SetFillColor(uFramelessPanelColorDarker);

    this.SetShadowOn(true);
    this.SetBorderThickness(1);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);

    var headerString = hoverMsg.fShortText;
    var sc = hoverMsg.fShortCutText;
    if (sc != null) headerString = headerString + " (" + sc + ")";
    var tW = this.fToolW;
    var tH = this.fToolH;

    var hoverMargin = 6;
    if (fullMsg) {
      if (hoverMsg.fLargeMsg) tW = tW * 2;

      headerString = TruncateText(headerString, "bold 36px Aeonik", tW * 2);
      //this.SizePanel(tW,tH);
      var header = AddStaticText(this, hoverMargin, hoverMargin, headerString, true, "#000000");
      header.SetFontSize(14);
      header.AutoSize();
      tW =
        header.GetWidth() + hoverMargin * 2 > this.fToolW
          ? header.GetWidth() + hoverMargin * 2
          : this.fToolW;

      var longHMargin = 10;
      var longVMargin = 22;
      var wT;
      if (hoverMsg.fLargeMsg)
        wT = AddWrapText(
          this,
          longHMargin,
          longVMargin,
          tW - longHMargin * 2,
          hoverMsg.fLongText,
          false,
          "#FF0000",
          "Aeonik",
          18
        );
      else
        wT = AddWrapText(
          this,
          longHMargin,
          longVMargin,
          tW - longHMargin * 2,
          hoverMsg.fLongText,
          false,
          "#000000",
          "Aeonik",
          12
        );
      wT.fHorzOffset = 6;
      wT.AutoSize();
      tH = longVMargin + wT.GetHeight() + hoverMargin;
    } else {
      header = AddStaticText(this, hoverMargin, hoverMargin, headerString, false, "#000000");
      header.AutoSize();
      tW = header.GetWidth() + hoverMargin * 2;
      tH = header.GetHeight() + hoverMargin * 2;
    }

    this.SizePanel(tW, tH);
    maxW = maxW - 10;
    var rEdge = x + tW;
    if (rEdge > maxW) x = x - (rEdge - maxW);

    maxH = maxH - 10;
    y = y + kShiftDown;
    var bEdge = y + tH;
    if (bEdge > maxH) y = yTop - tH - 10;

    this.PositionPanel(x, y);

    if (fullMsg) header.SetTextColor("#FFFFFF");
    else header.SetTextColor("#FFFFFF");
    if (wT) wT.SetTextColor("#FFFFFF");
  }
}
